import React, { createContext, useContext, useState } from 'react';

const CustomSearchContext = createContext();

export const CustomSearchProvider = ({ children }) => {
  const [searchValue, setSearchValue] = useState(null);

  const updateSearchValue = newValue => {
    setSearchValue(newValue);
  };

  return (
    <CustomSearchContext.Provider value={{ searchValue, updateSearchValue }}>
      {children}
    </CustomSearchContext.Provider>
  );
};

export const useCustomSearch = () => {
  const context = useContext(CustomSearchContext);
  if (!context) {
    throw new Error(
      'useCustomSearch must be used within a CustomSearchProvider'
    );
  }
  return context;
};
